export const DEFAULT_FORM_KIND = "general_contact";

export const PURPOSE_OPTIONS = [
  { value: "general_contact", label: "Allgemeine Kontaktanfrage" },
  { value: "demo_request", label: "Demo-Anfrage" },
  { value: "strategy_call", label: "Strategiegespräch" },
  { value: "whitepaper_download", label: "Whitepaper-Download" },
  { value: "callback_request", label: "Rückrufwunsch" },
  { value: "other", label: "Sonstiges" },
];

const FORM_KIND_LABELS = {
  general_contact: "Allgemeiner Kontakt",
  demo_request: "Demo-Anfrage",
  strategy_call: "Strategiegespräch",
  whitepaper_download: "Whitepaper-Download",
  callback_request: "Rückrufwunsch",
  other: "Sonstiges",
};

export function buildLeadSourceDefault(formKind) {
  if (formKind === "demo_request") {
    return "DEMO_REQUEST";
  }
  if (formKind === "whitepaper_download") {
    return "WEBSITE";
  }
  return "CONTACT_FORM";
}

export function getDefaultPlacementPurposeKey(formKind) {
  return (formKind || "").trim() || DEFAULT_FORM_KIND;
}

export function isKnownPurposeKey(value) {
  return PURPOSE_OPTIONS.some((option) => option.value === value);
}

export function getPurposeOptions(currentValue) {
  if (currentValue && !isKnownPurposeKey(currentValue)) {
    return [{ value: currentValue, label: "Benutzerdefiniert" }, ...PURPOSE_OPTIONS];
  }
  return PURPOSE_OPTIONS;
}

export function formatPurposeLabel(value) {
  const match = PURPOSE_OPTIONS.find((option) => option.value === value);
  if (match) {
    return match.label;
  }
  if ((value || "").trim()) {
    return "Benutzerdefiniert";
  }
  return "Nicht gesetzt";
}

export function formatFormKindLabel(formKind) {
  return FORM_KIND_LABELS[formKind] || formKind || "Ohne Typ";
}

export function formatEmbedModeLabel(embedMode) {
  if (embedMode === "standalone") {
    return "Standalone-Seite";
  }
  if (embedMode === "inline") {
    return "Inline-Widget";
  }
  if (embedMode === "modal") {
    return "Modal";
  }
  return embedMode || "Unbekannt";
}

export function buildEmbedScriptUrl(baseUrl) {
  const normalizedBaseUrl = (baseUrl || "").trim().replace(/\/+$/, "");
  return `${normalizedBaseUrl}/embed/v1/fyrecrm-form.js`;
}

export function buildPlacementEmbedSnippet(baseUrl, placementKey) {
  return [
    `<div data-fyrecrm-form data-placement-key="${placementKey}"></div>`,
    `<script src="${buildEmbedScriptUrl(baseUrl)}" async></script>`,
  ].join("\n");
}

export function normalizeAllowedOrigin(value) {
  const text = String(value || "").trim();
  if (!text) {
    throw new Error("Bitte nur vollständige Origins ohne Pfad eingeben.");
  }
  let url;
  try {
    url = new URL(text);
  } catch (_error) {
    throw new Error("Bitte nur vollständige Origins ohne Pfad eingeben.");
  }
  const protocol = (url.protocol || "").toLowerCase();
  if (protocol !== "http:" && protocol !== "https:") {
    throw new Error("Bitte nur vollständige Origins ohne Pfad eingeben.");
  }
  if (!url.hostname || url.username || url.password || url.search || url.hash) {
    throw new Error("Bitte nur vollständige Origins ohne Pfad eingeben.");
  }
  if ((url.pathname || "").trim() && url.pathname !== "/") {
    throw new Error("Bitte nur vollständige Origins ohne Pfad eingeben.");
  }
  const hostname = url.hostname.toLowerCase();
  const port = url.port
    && !((protocol === "http:" && url.port === "80") || (protocol === "https:" && url.port === "443"))
      ? `:${url.port}`
      : "";
  return `${protocol}//${hostname}${port}`;
}

export function normalizeAllowedOrigins(origins) {
  if (!Array.isArray(origins)) {
    return [];
  }
  const normalized = [];
  const seen = new Set();
  origins.forEach((origin) => {
    const text = String(origin || "").trim();
    if (!text) {
      return;
    }
    const value = normalizeAllowedOrigin(text);
    if (seen.has(value)) {
      return;
    }
    normalized.push(value);
    seen.add(value);
  });
  return normalized;
}

export function formatAllowedOriginsInput(origins) {
  return normalizeAllowedOrigins(origins).join("\n");
}

export function parseAllowedOriginsInput(value) {
  const text = String(value || "").trim();
  if (!text) {
    return [];
  }
  return normalizeAllowedOrigins(text.split(/\r?\n/));
}

export function getAllowedOriginsValidationError(value) {
  try {
    parseAllowedOriginsInput(value);
    return "";
  } catch (error) {
    return error.message || "Bitte nur vollständige Origins ohne Pfad eingeben.";
  }
}
